import { render, staticRenderFns } from "./permit.vue?vue&type=template&id=9ca9e7a0&scoped=true"
import script from "./permit.vue?vue&type=script&lang=js"
export * from "./permit.vue?vue&type=script&lang=js"
import style0 from "./permit.vue?vue&type=style&index=0&id=9ca9e7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca9e7a0",
  null
  
)

export default component.exports